/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacilityTimezone
 */
export interface FacilityTimezone {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    createdAt?: string;
    /**
     * 
     */
    updatedAt?: string;
    /**
     * 
     */
    deletedAt?: string;
}

/**
 * Check if a given object implements the FacilityTimezone interface.
 */
export function instanceOfFacilityTimezone(value: object): value is FacilityTimezone {
    return true;
}

export function FacilityTimezoneFromJSON(json: any): FacilityTimezone {
    return FacilityTimezoneFromJSONTyped(json, false);
}

export function FacilityTimezoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityTimezone {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'deletedAt': json['deletedAt'] == null ? undefined : json['deletedAt'],
    };
}

export function FacilityTimezoneToJSON(json: any): FacilityTimezone {
    return FacilityTimezoneToJSONTyped(json, false);
}

export function FacilityTimezoneToJSONTyped(value?: FacilityTimezone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'deletedAt': value['deletedAt'],
    };
}

